import {
  LayoutHeaderContextProvider,
  LayoutHeaderContextType,
} from '../modules/LayoutHeaderContext';
import LayoutProvider from '../providers/LayoutProvider';

import Header from '../app/pages/Header';

export type MrtHeaderProps = Omit<
  LayoutHeaderContextType,
  | 'isFlightMode'
  | 'setTheme'
  | 'setSize'
  | 'setDisabled'
  | 'setExcludeLnb'
  // PST-570 — GNB items 는 헤더가 region 기준 self-fetch 로 단일 소스화한다.
  // 소비처는 넘기지 않아도 되며(생략 시 defaultState 폴백 → self-fetch override), 넘기면 폴백으로만 쓰인다.
  | 'mainVerticalItems'
  | 'subVerticalItems'
  | 'lnbVerticalItems'
> & {
  targetEnv: string;
  defaultIsMobile?: boolean;
  hideGnb?: boolean;
  hideLnb?: boolean;
  mainVerticalItems?: LayoutHeaderContextType['mainVerticalItems'];
  subVerticalItems?: LayoutHeaderContextType['subVerticalItems'];
  lnbVerticalItems?: LayoutHeaderContextType['lnbVerticalItems'];
};

const MrtHeader = (props: MrtHeaderProps) => {
  return (
    <LayoutProvider targetEnv={props.targetEnv} defaultIsMobile={props.defaultIsMobile}>
      <LayoutHeaderContextProvider initialState={props}>
        <Header hideGnb={props.hideGnb} hideLnb={props.hideLnb} />
      </LayoutHeaderContextProvider>
    </LayoutProvider>
  );
};

export default MrtHeader;
